'use client';
import { useLoader } from '@/context/loaderContext';
import loadingGif from '../../../public/images/global/loading.gif';
import Image from 'next/image';
import { Transition } from '@headlessui/react';
import { Text } from '@/components';

export const OverlayLoader: React.FC = () => {
  const { loading } = useLoader();

  return (
    <Transition
      show={loading}
      enter='transition-opacity duration-300'
      enterFrom='opacity-0'
      enterTo='opacity-100'
      leave='transition-opacity duration-300'
      leaveFrom='opacity-100'
      leaveTo='opacity-0'>
      <div className='fixed block h-full w-full select-none bg-white/90 z-50'>
        <div className='absolute inset-0 flex flex-col items-center justify-center gap-y-6 z-50'>
          <div className='relative mx-auto aspect-square h-40 w-40 md:h-80 md:w-[20rem]'>
            <Image
              src={loadingGif}
              alt='Loading'
              title='Loading'
              className='object-contain'
              sizes='20vw'
              draggable={false}
              unoptimized
              fill
            />
          </div>
          <Text className='font-medium italic'>
            Writing Delicious Stories...
          </Text>
        </div>
      </div>
    </Transition>
  );
};
